/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response schema for retrieving Braintrust trace metadata for a conversation.
 */
export interface ConversationTraceMetadataResponse {
  /** The exported Braintrust root span ID for appending traces to this conversation. */
  braintrust_span_id?: string | null;
  /** The exported Braintrust child span ID for the clinic side of the conversation. */
  clinic_braintrust_span_id?: string | null;
  /** The Nori conversation tied to these spans */
  nori_conversation_id?: string | null;
}
